import React, { useEffect, useState } from "react";
import Bidding from "../components/Bidding";
import LoadingBox from "../components/LoadingBox";
import MessageBox from "../components/MessageBox";
import { useDispatch, useSelector } from "react-redux";
import { listBidding } from "../actions/biddingAction";
import LandingCarousel from "../components/Carousel";
import LazyLoad from "react-lazyload";
import AuctionCarousel from "../components/AuctionCarousel";
import Sidebar from "../components/Sidebar";
import axios from "axios";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
export default function BiddingScreen() {
  const dispatch = useDispatch();
  var [category, setCategory] = useState([]);
  const bidList = useSelector((state) => state.bidList);
  const { loading, error, products } = bidList;
  console.log(products, "productsproductsproducts");
  const [delasData, setdealsData] = useState([]);
  const [status, setStatus] = useState([]);
  // const fetchAlldata = () => {
  //   axios.get(`https://api.fortisab.com/api/users/getAllProductCategory`).then((res) => {
  //     res.data.forEach((element) => {
  //       if (element.categoryItem && !category.includes(element.categoryItem)) {
  //         setCategory((oldArray) => [...oldArray, element.categoryItem]);
  //         category = category.filter(function (value, index, array) {
  //           return array.indexOf(value) == index;
  //         });
  //       }
  //     });
  //   });
  // };
  // useEffect(() => {
  //   fetchAlldata();
  // }, []);
  useEffect(() => {
    dispatch(listBidding({}));
  }, [dispatch]);

  useEffect(() => {
    setdealsData(products);
  }, [products]);
  console.log(products, "products");
  const handleApply = (min, max) => {
    let filterData = products.filter(
      (res) => res.price >= min && res.price <= max
    );
    setdealsData(filterData);
  };
  return (
    <div style={{ display: "flex" }}>
      <div>
        <Sidebar
          handleApply={handleApply}
          status={status}
          setStatus={setStatus}
          category={category}
        />
      </div>
      <div>
        {loading ? (
          <LoadingBox></LoadingBox>
        ) : error ? (
          <MessageBox variant="danger">{error}</MessageBox>
        ) : (
          <LazyLoad>
            {" "}
            <div>
              {(status.includes("hot_delas") || !status.length) && (
                <>
                  <h1 className="glow hot-deal">
                    Hot Deals{" "}
                    <i
                      class="fa fa-cart-plus"
                      style={{ color: "#1FA8F8", fontSize: "30px" }}
                      aria-hidden="true"
                    ></i>{" "}
                  </h1>

                  <LandingCarousel data={delasData} />
                </>
              )}
              {/* {(status.includes("live_actions") || !status.length) && (
                <>
                  <h1 className="glow">
                    Live Auction{" "}
                    <i
                      class="fa fa-tint"
                      style={{ color: "orangeRed", fontSize: "30px" }}
                      aria-hidden="true"
                    ></i>{" "}
                  </h1>
                  <AuctionCarousel data={delasData} />
                </>
              )} */}
              {/* {(status.includes("marketplaces") || !status.length) && (
                <>
                  <h1 className="glow marketplace-title">
                    Marketplace{" "}
                    <i
                      class="fa fa-shopping-bag "
                      style={{ color: "#DA2754", fontSize: "30px" }}
                      aria-hidden="true"
                    ></i>{" "}
                  </h1>
                  <div className="row center Marketplace">
                    {delasData?.map((product) => (
                      <Bidding key={product._id} product={product}></Bidding>
                    ))}
                  </div>
                </>
              )} */}
            </div>
          </LazyLoad>
        )}
      </div>
    </div>
  );
}
